<div class="container menu">
  <div class="my-5">
    <div class="menu-container-titles text-center text-md-start text-lg-start">
      <p class="p-0 m-0 menu-titulo"><strong>Hola {{ userName | titlecase }},</strong></p>
      <p class="p-0 m-0 menu-subTitulo"> {{ subTituloHtml }} </p>
    </div>
    <div>
      <div
        class="d-flex flex-wrap justify-content-center justify-content-md-start justify-content-lg-start"
        >
        @for (menu of menuData; track menu; let i = $index) {
          @if (disabledVista(menu)) {
            <button class="menu-button"
              (mouseenter)="mouseEnter(i)"
              (mouseleave)="mouseLeave(i)"
              (click)="selectMenuButton(menu)">
              <div class="fs-16px h-100 d-flex flex-column w-100">
                @if (menu.icon !== '') {
                  <div class="top-container d-flex justify-content-end align-items-start w-100">
                    @if (menu.icon !== '') {
                      <div class="top-container d-flex justify-content-end align-items-start w-100">
                        <img [src]="menu.icon" class="svg-icon" alt="icon" [hidden]="menu.hover">
                        <img [src]="menu.iconHover" class="svg-icon" alt="icon-hover" [hidden]="!menu.hover">
                      </div>
                    }
                  </div>
                }
                <div class="bottom-container d-flex justify-content-start align-items-end h-100">
                  {{ menu.title }}
                </div>
              </div>
            </button>
          }
        }
      </div>
    </div>
  </div>
</div>
